import React from 'react';

const BotonAsignar = (props) => {
    let usuariosSeleccionados;
    let usuariosSeleccionadosList = [];

    if (props.usuariosFiltrados != undefined) {
        usuariosSeleccionados = props.usuariosFiltrados.find(x => x.Seleccionado == true) != undefined ? props.usuariosFiltrados.filter(x => x.Seleccionado == true).length : 0;
        usuariosSeleccionadosList = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Activo == true);
    }

    return (
        <div className="dropdown">
            <button className="btn btn-cta" type="submit" title="Asignar el perfil a los usuarios seleccionados"
                onClick={() => props.asignarPerfil(usuariosSeleccionadosList)}>
                Asignar
            </button>
        </div>
    );
}

export default BotonAsignar